export default __webpack_public_path__ + "static/media/1-banner.a9344442.png";